import React, { PureComponent } from 'react'

import { injectIntl, FormattedHTMLMessage } from 'react-intl'

import { scrollTo } from './services/utils'

import Meeting from './Meeting'
import Map from './Map'

import './Meetings.css'

export default injectIntl(
  class Meetings extends PureComponent {
    componentDidUpdate(prevProps) {
      const { meetings } = this.props
      if (meetings !== prevProps.meetings) {
        scrollTo(this.element)
      }
    }
    render() {
      const { meetings, meeting, onChanged } = this.props
      if (meetings.length > 0) {
        return (
          <div ref={el => (this.element = el)} className="cm-meetings">
            <h2 className="cm-meetings--title">
              <FormattedHTMLMessage id="meeting_places" />
            </h2>
            <div className="cm-meetings--outer">
              <div className="cm-meetings--list">
                <div className="cm-meetings--inner">
                  {meetings.map(m => (
                    <Meeting
                      meeting={m}
                      key={m.code}
                      onChanged={onChanged}
                      selected={meeting === m.code}
                    />
                  ))}
                </div>
              </div>
              <Map
                markers={meetings.map(m => {
                  return { location: m.location, code: m.code }
                })}
                selectedMarker={meeting}
                onChanged={onChanged}
              />
            </div>
          </div>
        )
      }
    }
  }
)



// WEBPACK FOOTER //
// ./src/Meetings.js